(function(){
  // ---- SIZE DATA ----
  function getSizeChartData() {
    return window.SizeChartData || {};
  }


  var state = {
    garment: 'K',
    type: 'G',
    height: 'S',
    bodyType: 'A',
    chest: '40',
    unit: 'cm'
  };

  var garmentNames = {
    K: 'Kessler (Polo)',
    S: 'Sawyer (Crew Neck)',
    A: 'Atticus (Button Down)',
    H: 'Harrington',
    N: 'Newman (Unstructured Blazer)'
  };

  // Display metadata for the collapsed card (name + type displayed separately).
  var garmentDisplay = {
    K: { name: 'Kessler',    type: 'Polo' },
    S: { name: 'Sawyer',     type: 'Crew Neck' },
    A: { name: 'Atticus',    type: 'Button Down' },
    H: { name: 'Harrington', type: 'Jacket' },
    N: { name: 'Newman',     type: 'Unstructured Blazer' }
  };

  // Garment items for each garment
  var garmentItems = {
    K: ['Garment Chest','Garment Waist','Garment Hem','Garment Length','Garment Shoulder','Garment Biceps','Garment Sleeve Length','Garment Sleeve Hem'],
    S: ['Garment Chest','Garment Waist','Garment Hem','Garment Length','Garment Shoulder','Garment Biceps','Garment Sleeve Length','Garment Sleeve Hem'],
    A: ['Garment Chest','Garment Waist','Garment Hem','Garment Length','Garment Shoulder','Garment Biceps','Garment Elbow','Garment Sleeve Hem','Garment Sleeve Length'],
    H: ['Garment Chest','Garment Waist','Garment Hem','Garment Length','Garment Shoulder','Garment Biceps','Garment Elbow','Garment Sleeve Hem','Garment Sleeve Length'],
    N: ['Garment Chest','Garment Waist','Garment Hem','Garment Length','Garment Shoulder','Garment Biceps','Garment Elbow','Garment Sleeve Hem','Garment Sleeve Length']
  };
  var bodyItems = {
    K: ['Body Chest Girth','Body Waist Girth','Body Hip Girth','Body Back Shoulder Width','Body Biceps Girth','Body Arm Length','Body Shoulder to Hip'],
    S: ['Body Chest Girth','Body Waist Girth','Body Hip Girth','Body Back Shoulder Width','Body Biceps Girth','Body Arm Length','Body Shoulder to Hip'],
    A: ['Body Chest Girth','Body Waist Girth','Body Hip Girth','Body Back Shoulder Width','Body Biceps Girth','Body Arm Length','Body Shoulder to Hip'],
    H: ['Body Chest Girth','Body Waist Girth','Body Hip Girth','Body Back Shoulder Width','Body Biceps Girth','Body Arm Length','Body Shoulder to Hip'],
    N: ['Body Chest Girth','Body Waist Girth','Body Hip Girth','Body Back Shoulder Width','Body Biceps Girth','Body Arm Length','Body Shoulder to Hip']
  };

  var shortNames = {
    'Garment Chest': 'Chest', 'Garment Waist': 'Waist', 'Garment Hem': 'Hem',
    'Garment Length': 'Length', 'Garment Shoulder': 'Shoulder', 'Garment Biceps': 'Biceps',
    'Garment Elbow': 'Elbow', 'Garment Sleeve Hem': 'Sleeve Hem', 'Garment Sleeve Length': 'Sleeve Length',
    'Body Chest Girth': 'Chest', 'Body Waist Girth': 'Waist', 'Body Hip Girth': 'Hip',
    'Body Back Shoulder Width': 'Shoulder', 'Body Biceps Girth': 'Biceps',
    'Body Arm Length': 'Arm Length', 'Body Shoulder to Hip': 'Shoulder to Hip'
  };

  function getMeasurement(item) {
    try {
      var sd = getSizeChartData();
      var d = sd[state.garment][state.type][item][state.height][state.bodyType][state.chest];
      if (!d) return null;
      return state.unit === 'cm' ? d[0] : d[1];
    } catch(e) { return null; }
  }

  function getUnit() { return state.unit === 'cm' ? 'cm' : 'in'; }

  function getItems() {
    return state.type === 'G' ? garmentItems[state.garment] : bodyItems[state.garment];
  }

  // ---- SVG DIAGRAM RENDERING ----
  // Helper: scale a measurement value to SVG pixels relative to a base
  function scaleVal(val, baseVal, basePx) {
    if (!val || !baseVal) return basePx;
    return basePx * (val / baseVal);
  }

  function clampVal(val, min, max) {
    return Math.max(min, Math.min(max, val));
  }

  function renderDiagram() {
    var area = document.getElementById('sc-diagram-area');
    var items = getItems();
    var measurements = {};
    var rawMeas = {};
    items.forEach(function(item) {
      var v = getMeasurement(item);
      if (v !== null) {
        measurements[shortNames[item] || item] = v;
        rawMeas[shortNames[item] || item] = v;
      }
    });

    var isHarrington = state.garment === 'H';
    var isAtticus = state.garment === 'A';
    var isNewman = state.garment === 'N';
    var isBody = state.type === 'B';
    var u = getUnit();

    var svgW = 700, svgH = 255;
    var cx = 350;

    var svg = '<svg viewBox="0 0 ' + svgW + ' ' + svgH + '" xmlns="http://www.w3.org/2000/svg" style="max-width:620px;width:100%;">';

    if (isBody) {
      // ---- HUMAN FIGURE - cleaner line drawing with less curvature ----
      var baseBodyChest = state.unit === 'cm' ? 102 : 40.16;
      var shoulderW = clampVal(scaleVal(rawMeas['Shoulder'], baseBodyChest * 0.46, 46), 40, 56);
      var chestW = clampVal(scaleVal(rawMeas['Chest'], baseBodyChest, 39), 34, 52);
      var waistW = clampVal(scaleVal(rawMeas['Waist'], baseBodyChest * 0.86, 31), 24, 44);
      var hipW = clampVal(scaleVal(rawMeas['Hip'], baseBodyChest * 0.95, 34), 28, 48);
      var bicepsW = clampVal(scaleVal(rawMeas['Biceps'], baseBodyChest * 0.34, 8), 6, 13);
      var armLen = clampVal(scaleVal(rawMeas['Arm Length'], baseBodyChest * 0.62, 112), 98, 128);
      var torsoH = clampVal(scaleVal(rawMeas['Shoulder to Hip'], baseBodyChest * 0.66, 75), 66, 92);
      var shoulderY = 45;
      var chestY = 72;
      var waistY = Math.round(shoulderY + torsoH * 0.58);
      var hipY = Math.round(shoulderY + torsoH);
      var crotchY = hipY + 24;
      var armEndY = Math.round(shoulderY + armLen);
      var footY = clampVal(crotchY + 80, 212, 232);
      var rightLaneX = 552;
      var leftLaneX = 148;

      svg += '<g transform="translate(' + cx + ',14)">';
      svg += '<ellipse cx="0" cy="14" rx="13" ry="15" class="sc-body-shape"/>';
      svg += '<path d="M-6,29 L-6,38 M6,29 L6,38" class="sc-detail-line"/>';
      svg += '<path d="M-8,38 L' + (-shoulderW) + ',' + shoulderY + ' L' + (-chestW) + ',' + chestY + ' L' + (-waistW) + ',' + waistY + ' L' + (-hipW) + ',' + hipY + ' L' + (-hipW+4) + ',' + crotchY + ' L-25,171 L-21,' + footY + ' L-12,' + footY + ' L-8,178 L-3,' + crotchY + ' L3,' + crotchY + ' L8,178 L12,' + footY + ' L21,' + footY + ' L25,171 L' + (hipW-4) + ',' + crotchY + ' L' + hipW + ',' + hipY + ' L' + waistW + ',' + waistY + ' L' + chestW + ',' + chestY + ' L' + shoulderW + ',' + shoulderY + ' L8,38 Z" class="sc-body-shape"/>';
      svg += '<path d="M' + (-shoulderW) + ',' + shoulderY + ' L' + (-(shoulderW+10)) + ',58 L' + (-(shoulderW+14)) + ',100 L' + (-(shoulderW+12)) + ',' + armEndY + ' L' + (-(shoulderW+5)) + ',' + armEndY + ' L' + (-(shoulderW+6)) + ',101 L' + (-(shoulderW+4)) + ',62 L' + (-chestW) + ',' + chestY + ' Z M' + shoulderW + ',' + shoulderY + ' L' + (shoulderW+10) + ',58 L' + (shoulderW+14) + ',100 L' + (shoulderW+12) + ',' + armEndY + ' L' + (shoulderW+5) + ',' + armEndY + ' L' + (shoulderW+6) + ',101 L' + (shoulderW+4) + ',62 L' + chestW + ',' + chestY + ' Z" class="sc-body-shape"/>';
      svg += '<path d="M' + (-chestW) + ',' + chestY + ' L' + chestW + ',' + chestY + ' M' + (-waistW) + ',' + waistY + ' L' + waistW + ',' + waistY + ' M' + (-hipW) + ',' + hipY + ' L' + hipW + ',' + hipY + ' M0,' + chestY + ' L0,' + crotchY + '" class="sc-detail-soft"/>';
      svg += '</g>';

      var by = 14; // g translate offset
      var bodyPositions = {
        'Shoulder':       { x1: cx-shoulderW, y1:by+shoulderY, x2: cx+shoulderW, y2:by+shoulderY, lx: rightLaneX, ly:32,  side:'right' },
        'Chest':          { x1: cx-chestW,    y1:by+chestY,    x2: cx+chestW,    y2:by+chestY,    lx: rightLaneX, ly:74,  side:'right' },
        'Waist':          { x1: cx-waistW,    y1:by+waistY,    x2: cx+waistW,    y2:by+waistY,    lx: rightLaneX, ly:116, side:'right' },
        'Hip':            { x1: cx-hipW,      y1:by+hipY,      x2: cx+hipW,      y2:by+hipY,      lx: rightLaneX, ly:158, side:'right' },
        'Shoulder to Hip':{ x1: cx+8,         y1:by+shoulderY, x2: cx+8,         y2:by+hipY,      lx: rightLaneX, ly:208, side:'right', leadFrom:'end' },
        'Biceps':         { x1: cx-shoulderW-bicepsW-8, y1:by+96, x2: cx-shoulderW+bicepsW, y2:by+96, lx: leftLaneX, ly:74, side:'left' },
        'Arm Length':     { x1: cx-shoulderW-9, y1:by+58, x2: cx-shoulderW-9, y2:by+armEndY, lx: leftLaneX, ly:126, side:'left', leadFrom:'end' }
      };

      for (var name in measurements) {
        var pos = bodyPositions[name];
        if (!pos) continue;
        svg += renderMeasAnnotation(pos, name, measurements[name] + ' ' + u);
      }

    } else if (isNewman) {
      // ---- NEWMAN UNSTRUCTURED BLAZER - soft notch lapel, 2-button, patch pockets ----
      var baseChest = state.unit === 'cm' ? 113 : 44.49;
      var cw = scaleVal(rawMeas['Chest'], baseChest, 64);
      var ww = scaleVal(rawMeas['Waist'], baseChest, 60);
      var hw = scaleVal(rawMeas['Hem'], baseChest * 0.96, 60);
      var sw = scaleVal(rawMeas['Shoulder'], baseChest * 0.41, 52);
      var bodyH = scaleVal(rawMeas['Length'], baseChest * 0.66, 168);
      if (bodyH > 192) bodyH = 192;

      var wY = Math.round(bodyH * 0.56);
      var sl = -sw, sr = sw;
      var armpitY = 50;
      var sleeveReach = scaleVal(rawMeas['Sleeve Length'], baseChest * 0.72, 102);
      if (sleeveReach < 92) sleeveReach = 92;
      if (sleeveReach > 114) sleeveReach = 114;
      var cuffW = 22;
      var cuffY = Math.min(bodyH - 16, 138);
      var leftCuffX = -sw - sleeveReach;
      var rightCuffX = sw + sleeveReach;

      // Notch lapel geometry
      var lapelTopY = 4;        // where lapel meets shoulder
      var notchY = 36;          // height of the notch
      var notchInnerX = 11;     // collar tip horizontal inset
      var notchOuterX = 22;     // lapel point horizontal extent
      var breakY = 78;          // button stance / lapel break point
      var breakX = 6;           // where lapels meet at top button

      svg += '<g transform="translate(' + cx + ',22)">';

      // Main jacket body with relaxed shoulders and gentle sleeve drop
      svg += '<path d="';
      svg += 'M-22,' + lapelTopY + ' ';
      svg += 'L' + sl + ',18 ';
      svg += 'L' + (sl - 30) + ',34 ';
      svg += 'L' + (leftCuffX - 2) + ',' + (cuffY - 8) + ' ';
      svg += 'L' + (leftCuffX + cuffW) + ',' + (cuffY + 4) + ' ';
      svg += 'L' + (sl - 18) + ',66 ';
      svg += 'L' + (-cw) + ',' + armpitY + ' ';
      svg += 'L' + (-ww - 1) + ',' + wY + ' ';
      svg += 'L' + (-hw) + ',' + bodyH + ' ';
      svg += 'Q-2,' + (bodyH + 4) + ' -2,' + (bodyH - 4) + ' ';
      svg += 'L-2,' + breakY + ' ';
      svg += 'L-' + breakX + ',' + breakY + ' ';
      // Left lapel (top edge, going up): break point -> notch -> shoulder
      svg += 'L-' + notchOuterX + ',' + notchY + ' ';
      svg += 'L-' + notchInnerX + ',' + (notchY + 6) + ' ';
      svg += 'L-12,' + lapelTopY + ' ';
      svg += 'L-22,' + lapelTopY + ' ';
      svg += 'Z';
      svg += '" class="sc-garment-shape"/>';

      // Right half (mirrored). Drawn as a separate path so the placket gap stays visible.
      svg += '<path d="';
      svg += 'M22,' + lapelTopY + ' ';
      svg += 'L' + sr + ',18 ';
      svg += 'L' + (sr + 30) + ',34 ';
      svg += 'L' + (rightCuffX + 2) + ',' + (cuffY - 8) + ' ';
      svg += 'L' + (rightCuffX - cuffW) + ',' + (cuffY + 4) + ' ';
      svg += 'L' + (sr + 18) + ',66 ';
      svg += 'L' + cw + ',' + armpitY + ' ';
      svg += 'L' + (ww + 1) + ',' + wY + ' ';
      svg += 'L' + hw + ',' + bodyH + ' ';
      svg += 'Q2,' + (bodyH + 4) + ' 2,' + (bodyH - 4) + ' ';
      svg += 'L2,' + breakY + ' ';
      svg += 'L' + breakX + ',' + breakY + ' ';
      svg += 'L' + notchOuterX + ',' + notchY + ' ';
      svg += 'L' + notchInnerX + ',' + (notchY + 6) + ' ';
      svg += 'L12,' + lapelTopY + ' ';
      svg += 'L22,' + lapelTopY + ' ';
      svg += 'Z';
      svg += '" class="sc-garment-shape"/>';

      // Lapel inner roll/crease lines (soft, suggesting unstructured fold)
      svg += '<path d="M-12,' + lapelTopY + ' L-' + breakX + ',' + breakY + ' M12,' + lapelTopY + ' L' + breakX + ',' + breakY + '" class="sc-detail-line"/>';

      // Notch indicator (small gorge line)
      svg += '<path d="M-' + notchInnerX + ',' + (notchY + 6) + ' L-' + (notchInnerX - 4) + ',' + (notchY + 1) + ' M' + notchInnerX + ',' + (notchY + 6) + ' L' + (notchInnerX - 4) + ',' + (notchY + 1) + '" class="sc-detail-soft"/>';

      // Buttons (2-button stance)
      var btn1Y = breakY + 4;
      var btn2Y = breakY + 30;
      svg += '<circle cx="0" cy="' + btn1Y + '" r="2.2" fill="none" stroke="#999" stroke-width="0.9"/>';
      svg += '<circle cx="0" cy="' + btn1Y + '" r="0.7" fill="#999"/>';
      svg += '<circle cx="0" cy="' + btn2Y + '" r="2.2" fill="none" stroke="#999" stroke-width="0.9"/>';
      svg += '<circle cx="0" cy="' + btn2Y + '" r="0.7" fill="#999"/>';

      // Front opening (subtle line from second button down through hem)
      svg += '<path d="M0,' + (btn2Y + 6) + ' L0,' + (bodyH - 4) + '" class="sc-detail-soft" stroke-dasharray="3 3"/>';

      // Cuff lines (gentle, 2-button cuff hint)
      svg += '<path d="M' + (leftCuffX - 2) + ',' + (cuffY - 8) + ' L' + (leftCuffX + cuffW) + ',' + (cuffY + 4) + ' M' + (rightCuffX + 2) + ',' + (cuffY - 8) + ' L' + (rightCuffX - cuffW) + ',' + (cuffY + 4) + '" class="sc-detail-line"/>';
      // Tiny cuff buttons
      svg += '<circle cx="' + (leftCuffX + 6) + '" cy="' + (cuffY - 1) + '" r="0.8" fill="#aaa"/>';
      svg += '<circle cx="' + (leftCuffX + 12) + '" cy="' + (cuffY + 1) + '" r="0.8" fill="#aaa"/>';
      svg += '<circle cx="' + (rightCuffX - 6) + '" cy="' + (cuffY - 1) + '" r="0.8" fill="#aaa"/>';
      svg += '<circle cx="' + (rightCuffX - 12) + '" cy="' + (cuffY + 1) + '" r="0.8" fill="#aaa"/>';

      // Chest welt pocket (left side)
      svg += '<path d="M-30,' + (armpitY + 10) + ' L-12,' + (armpitY + 8) + '" class="sc-detail-line" stroke-width="1.4"/>';

      // Patch pockets (hip level) - characteristic of unstructured blazer
      var pocketTopY = wY + 18;
      var pocketBotY = wY + 50;
      svg += '<path d="M-50,' + pocketTopY + ' L-22,' + pocketTopY + ' L-22,' + pocketBotY + ' L-48,' + pocketBotY + ' Z" class="sc-detail-line"/>';
      svg += '<path d="M50,' + pocketTopY + ' L22,' + pocketTopY + ' L22,' + pocketBotY + ' L48,' + pocketBotY + ' Z" class="sc-detail-line"/>';

      // Hem curve detail (soft, rounded hem typical of unstructured)
      svg += '<path d="M' + (-hw) + ',' + (bodyH - 6) + ' Q0,' + (bodyH + 2) + ' ' + hw + ',' + (bodyH - 6) + '" class="sc-detail-soft"/>';

      // Side seam hints
      svg += '<path d="M' + (-ww + 5) + ',' + (wY - 4) + ' L' + (-hw + 3) + ',' + (bodyH - 4) + ' M' + (ww - 5) + ',' + (wY - 4) + ' L' + (hw - 3) + ',' + (bodyH - 4) + '" class="sc-detail-soft"/>';

      svg += '</g>';

      // Measurement positions
      var gy = 22;
      var slOuter = leftCuffX;
      var rightLaneX = 552;
      var leftLaneX = 148;

      var nPositions = {
        'Shoulder':      { x1: cx - sw, y1: gy + 16, x2: cx + sw, y2: gy + 16, lx: rightLaneX, ly: 26, side: 'right' },
        'Chest':         { x1: cx - cw, y1: gy + armpitY, x2: cx + cw, y2: gy + armpitY, lx: rightLaneX, ly: 70, side: 'right' },
        'Waist':         { x1: cx - ww, y1: gy + wY, x2: cx + ww, y2: gy + wY, lx: rightLaneX, ly: 112, side: 'right' },
        'Hem':           { x1: cx - hw, y1: gy + bodyH, x2: cx + hw, y2: gy + bodyH, lx: rightLaneX, ly: 156, side: 'right' },
        'Length':        { x1: cx + 12, y1: gy + 8, x2: cx + 12, y2: gy + bodyH, lx: rightLaneX, ly: 206, side: 'right', leadFrom: 'end' },
        'Biceps':        { x1: cx + sl - 16, y1: gy + 28, x2: cx + sl - 28, y2: gy + 58, leadX: cx + sl - 22, leadY: gy + 43, lx: leftLaneX, ly: 36, side: 'left' },
        'Elbow':         { x1: cx + slOuter + 32, y1: gy + 94, x2: cx + slOuter + 56, y2: gy + 80, lx: leftLaneX, ly: 78, side: 'left' },
        'Sleeve Hem':    { x1: cx + slOuter - 2, y1: gy + cuffY - 8, x2: cx + slOuter + cuffW, y2: gy + cuffY + 4, lx: leftLaneX, ly: 120, side: 'left' },
        'Sleeve Length': { x1: cx + sl - 4, y1: gy + 18, x2: cx + slOuter + 8, y2: gy + cuffY - 2, lx: leftLaneX, ly: 166, side: 'left' }
      };
      for (var name in measurements) {
        var pos = nPositions[name];
        if (!pos) continue;
        svg += renderMeasAnnotation(pos, name, measurements[name] + ' ' + u);
      }

    } else if (isAtticus) {
      // ---- ATTICUS BUTTON DOWN SHIRT - full sleeves + collar + full button placket ----
      var baseChest = state.unit === 'cm' ? 109 : 42.91;
      var cw = scaleVal(rawMeas['Chest'], baseChest, 62);
      var ww = scaleVal(rawMeas['Waist'], baseChest, 60);
      var hw = scaleVal(rawMeas['Hem'], baseChest * 0.95, 58);
      var sw = scaleVal(rawMeas['Shoulder'], baseChest * 0.42, 50);
      var bodyH = scaleVal(rawMeas['Length'], baseChest * 0.68, 165);
      if (bodyH > 190) bodyH = 190;

      var wY = Math.round(bodyH * 0.55);
      var sl = -sw, sr = sw;
      var armpitY = 48;
      var sleeveReach = scaleVal(rawMeas['Sleeve Length'], baseChest * 0.72, 100);
      if (sleeveReach < 90) sleeveReach = 90;
      if (sleeveReach > 112) sleeveReach = 112;
      var cuffW = 20;
      var cuffY = Math.min(bodyH - 18, 135);
      var leftCuffX = -sw - sleeveReach;
      var rightCuffX = sw + sleeveReach;

      svg += '<g transform="translate(' + cx + ',22)">';

      // Main shirt body with full sleeves
      svg += '<path d="';
      svg += 'M-20,4 ';
      svg += 'L' + sl + ',17 ';
      svg += 'L' + (sl - 30) + ',32 ';
      svg += 'L' + (leftCuffX - 2) + ',' + (cuffY - 6) + ' ';
      svg += 'L' + (leftCuffX + cuffW) + ',' + (cuffY + 4) + ' ';
      svg += 'L' + (sl - 20) + ',64 ';
      svg += 'L' + (-cw) + ',' + armpitY + ' ';
      svg += 'L' + (-ww - 2) + ',' + wY + ' ';
      svg += 'L' + (-hw) + ',' + bodyH + ' ';
      svg += 'Q0,' + (bodyH + 8) + ' ' + hw + ',' + bodyH + ' ';
      svg += 'L' + (ww + 2) + ',' + wY + ' ';
      svg += 'L' + cw + ',' + armpitY + ' ';
      svg += 'L' + (sr + 20) + ',64 ';
      svg += 'L' + (rightCuffX - cuffW) + ',' + (cuffY + 4) + ' ';
      svg += 'L' + (rightCuffX + 2) + ',' + (cuffY - 6) + ' ';
      svg += 'L' + (sr + 30) + ',32 ';
      svg += 'L' + sr + ',17 ';
      svg += 'L20,4 ';
      svg += 'L10,18 L0,11 L-10,18 Z';
      svg += '" class="sc-garment-shape"/>';

      // Collar (button-down style with pointed collar tips)
      svg += '<path d="M-22,2 Q0,-8 22,2 L12,18 L0,11 L-12,18 Z" class="sc-detail-line"/>';
      // Collar tips fold lines
      svg += '<path d="M-22,2 L-16,12 M22,2 L16,12" class="sc-detail-soft"/>';

      // Full button placket line
      svg += '<path d="M0,11 L0,' + (bodyH - 2) + '" class="sc-detail-line" stroke-dasharray="5 4"/>';

      // Buttons down the front
      var btnSpacing = (bodyH - 20) / 7;
      for (var bi = 0; bi < 7; bi++) {
        var btnY = 20 + bi * btnSpacing;
        svg += '<circle cx="0" cy="' + btnY + '" r="2" fill="none" stroke="#999" stroke-width="0.8"/>';
        svg += '<circle cx="0" cy="' + btnY + '" r="0.6" fill="#999"/>';
      }

      // Cuff lines
      svg += '<path d="M' + (leftCuffX - 2) + ',' + (cuffY - 6) + ' L' + (leftCuffX + cuffW) + ',' + (cuffY + 4) + ' M' + (rightCuffX + 2) + ',' + (cuffY - 6) + ' L' + (rightCuffX - cuffW) + ',' + (cuffY + 4) + '" class="sc-detail-line"/>';

      // Chest pocket (left side)
      svg += '<path d="M-8,52 L-8,72 L-28,72 L-28,52" class="sc-detail-soft"/>';
      svg += '<path d="M-8,52 L-18,56 L-28,52" class="sc-detail-soft"/>';

      // Hem curve detail
      svg += '<path d="M' + (-hw) + ',' + (bodyH - 8) + ' Q0,' + bodyH + ' ' + hw + ',' + (bodyH - 8) + '" class="sc-detail-soft"/>';

      // Side seam hints
      svg += '<path d="M' + (-ww + 5) + ',' + (wY - 4) + ' L' + (-hw + 3) + ',' + (bodyH - 4) + ' M' + (ww - 5) + ',' + (wY - 4) + ' L' + (hw - 3) + ',' + (bodyH - 4) + '" class="sc-detail-soft"/>';

      svg += '</g>';

      // Measurement positions
      var gy = 22;
      var slOuter = leftCuffX;
      var rightLaneX = 552;
      var leftLaneX = 148;

      var aPositions = {
        'Shoulder':      { x1: cx - sw, y1: gy + 15, x2: cx + sw, y2: gy + 15, lx: rightLaneX, ly: 26, side: 'right' },
        'Chest':         { x1: cx - cw, y1: gy + armpitY, x2: cx + cw, y2: gy + armpitY, lx: rightLaneX, ly: 68, side: 'right' },
        'Waist':         { x1: cx - ww, y1: gy + wY, x2: cx + ww, y2: gy + wY, lx: rightLaneX, ly: 110, side: 'right' },
        'Hem':           { x1: cx - hw, y1: gy + bodyH, x2: cx + hw, y2: gy + bodyH, lx: rightLaneX, ly: 154, side: 'right' },
        'Length':        { x1: cx + 10, y1: gy + 8, x2: cx + 10, y2: gy + bodyH, lx: rightLaneX, ly: 206, side: 'right', leadFrom: 'end' },
        'Biceps':        { x1: cx + sl - 16, y1: gy + 26, x2: cx + sl - 28, y2: gy + 56, leadX: cx + sl - 22, leadY: gy + 41, lx: leftLaneX, ly: 36, side: 'left' },
        'Elbow':         { x1: cx + slOuter + 30, y1: gy + 90, x2: cx + slOuter + 54, y2: gy + 76, lx: leftLaneX, ly: 78, side: 'left' },
        'Sleeve Hem':    { x1: cx + slOuter - 2, y1: gy + cuffY - 6, x2: cx + slOuter + cuffW, y2: gy + cuffY + 4, lx: leftLaneX, ly: 120, side: 'left' },
        'Sleeve Length': { x1: cx + sl - 4, y1: gy + 18, x2: cx + slOuter + 8, y2: gy + cuffY - 1, lx: leftLaneX, ly: 166, side: 'left' }
      };
      for (var name in measurements) {
        var pos = aPositions[name];
        if (!pos) continue;
        svg += renderMeasAnnotation(pos, name, measurements[name] + ' ' + u);
      }

    } else if (isHarrington) {
      // ---- HARRINGTON JACKET - cleaner full-sleeve outline with a wider armhole ----
      var baseChest = state.unit === 'cm' ? 111 : 43.76;
      var cw = scaleVal(rawMeas['Chest'], baseChest, 62);
      var ww = scaleVal(rawMeas['Waist'], baseChest, 60);
      var hw = scaleVal(rawMeas['Hem'], baseChest * 0.95, 58);
      var sw = scaleVal(rawMeas['Shoulder'], baseChest * 0.4, 48);
      var bodyH = scaleVal(rawMeas['Length'], baseChest * 0.6, 155);
      if (bodyH > 185) bodyH = 185;

      var wY = Math.round(bodyH*0.58);
      var sl = -sw, sr = sw;
      var armpitY = 50;
      var sleeveReach = scaleVal(rawMeas['Sleeve Length'], baseChest * 0.72, 100);
      if (sleeveReach < 92) sleeveReach = 92;
      if (sleeveReach > 112) sleeveReach = 112;
      var cuffW = 22;
      var cuffY = Math.min(bodyH - 18, 132);
      var leftCuffX = -sw - sleeveReach;
      var rightCuffX = sw + sleeveReach;

      svg += '<g transform="translate(' + cx + ',22)">';
      svg += '<path d="';
      svg += 'M-20,4 ';
      svg += 'L' + sl + ',17 ';
      svg += 'L' + (sl-32) + ',34 ';
      svg += 'L' + (leftCuffX-4) + ',' + (cuffY-8) + ' ';
      svg += 'L' + (leftCuffX+cuffW) + ',' + (cuffY+3) + ' ';
      svg += 'L' + (sl-22) + ',66 ';
      svg += 'L' + (-cw) + ',' + armpitY + ' ';
      svg += 'L' + (-ww-2) + ',' + wY + ' ';
      svg += 'L' + (-hw) + ',' + bodyH + ' ';
      svg += 'Q0,' + (bodyH+8) + ' ' + hw + ',' + bodyH + ' ';
      svg += 'L' + (ww+2) + ',' + wY + ' ';
      svg += 'L' + cw + ',' + armpitY + ' ';
      svg += 'L' + (sr+22) + ',66 ';
      svg += 'L' + (rightCuffX-cuffW) + ',' + (cuffY+3) + ' ';
      svg += 'L' + (rightCuffX+4) + ',' + (cuffY-8) + ' ';
      svg += 'L' + (sr+32) + ',34 ';
      svg += 'L' + sr + ',17 ';
      svg += 'L20,4 ';
      svg += 'L10,18 L0,29 L-10,18 Z';
      svg += '" class="sc-garment-shape"/>';

      svg += '<path d="M-21,0 Q0,-7 21,0 L11,18 L0,29 L-11,18 Z" class="sc-detail-line"/>';
      svg += '<path d="M0,29 L0,' + (bodyH-2) + '" class="sc-detail-line" stroke-dasharray="5 4"/>';
      svg += '<path d="M-36,' + (wY+6) + ' l22,-6 l3,16 l-23,6 Z M36,' + (wY+6) + ' l-22,-6 l-3,16 l23,6 Z" class="sc-detail-soft"/>';
      svg += '<path d="M' + (leftCuffX-4) + ',' + (cuffY-8) + ' L' + (leftCuffX+cuffW) + ',' + (cuffY+3) + ' M' + (rightCuffX+4) + ',' + (cuffY-8) + ' L' + (rightCuffX-cuffW) + ',' + (cuffY+3) + '" class="sc-detail-line"/>';
      svg += '<path d="M' + (-hw) + ',' + (bodyH-8) + ' Q0,' + bodyH + ' ' + hw + ',' + (bodyH-8) + '" class="sc-detail-soft"/>';
      svg += '</g>';

      // Measurement positions: labels spread out, right side for body, far left for sleeve.
      var gy = 22;
      var slOuter = leftCuffX; // leftmost point of sleeve
      var rightLaneX = 552;
      var leftLaneX = 148;

      var hPositions = {
        'Shoulder':      { x1: cx-sw, y1:gy+15, x2: cx+sw, y2:gy+15, lx: rightLaneX, ly:26, side:'right' },
        'Chest':         { x1: cx-cw, y1:gy+armpitY, x2: cx+cw, y2:gy+armpitY, lx: rightLaneX, ly:68, side:'right' },
        'Waist':         { x1: cx-ww, y1:gy+wY, x2: cx+ww, y2:gy+wY, lx: rightLaneX, ly:110, side:'right' },
        'Hem':           { x1: cx-hw, y1:gy+bodyH, x2: cx+hw, y2:gy+bodyH, lx: rightLaneX, ly:154, side:'right' },
        'Length':        { x1: cx+10, y1:gy+8, x2: cx+10, y2:gy+bodyH, lx: rightLaneX, ly:206, side:'right', leadFrom:'end' },
        'Biceps':        { x1: cx+sl-16, y1: gy+26, x2: cx+sl-28, y2: gy+58, leadX: cx+sl-22, leadY: gy+42, lx: leftLaneX, ly:36, side:'left' },
        'Elbow':         { x1: cx+slOuter+31, y1:gy+92, x2: cx+slOuter+55, y2:gy+78, lx: leftLaneX, ly:78, side:'left' },
        'Sleeve Hem':    { x1: cx+slOuter-4, y1:gy+cuffY-8, x2: cx+slOuter+cuffW, y2:gy+cuffY+3, lx: leftLaneX, ly:120, side:'left' },
        'Sleeve Length': { x1: cx+sl-4, y1:gy+18, x2: cx+slOuter+9, y2:gy+cuffY-3, lx: leftLaneX, ly:166, side:'left' }
      };
      for (var name in measurements) {
        var pos = hPositions[name];
        if (!pos) continue;
        svg += renderMeasAnnotation(pos, name, measurements[name] + ' ' + u);
      }

    } else {
      // ---- POLO / CREW NECK - clean short-sleeve line silhouette ----
      var baseChest = state.unit === 'cm' ? 107 : 42.26;
      var cw = scaleVal(rawMeas['Chest'], baseChest, 60);
      var ww = scaleVal(rawMeas['Waist'], baseChest, 58);
      var hw = scaleVal(rawMeas['Hem'], baseChest * 0.96, 56);
      var sw = scaleVal(rawMeas['Shoulder'], baseChest * 0.39, 50);
      var bodyH = scaleVal(rawMeas['Length'], baseChest * 0.63, 158);
      if (bodyH > 186) bodyH = 186;
      var sl = -sw, sr = sw;
      var wY = Math.round(bodyH*0.58);
      var armpitY = 48;
      var sleeveOut = 42;
      var sleeveTipY = 57;
      var neckPath = state.garment === 'K'
        ? 'L10,18 L0,11 L-10,18 L-20,4 Z'
        : 'Q0,18 -20,4 Z';

      svg += '<g transform="translate(' + cx + ',18)">';
      svg += '<path d="';
      svg += 'M-20,4 ';
      svg += 'L' + sl + ',17 ';
      svg += 'L' + (sl-sleeveOut+5) + ',31 ';
      svg += 'L' + (sl-sleeveOut+3) + ',' + sleeveTipY + ' ';
      svg += 'L' + (sl-18) + ',52 ';
      svg += 'L' + (-cw) + ',' + armpitY + ' ';
      svg += 'L' + (-ww) + ',' + wY + ' ';
      svg += 'L' + (-hw) + ',' + bodyH + ' ';
      svg += 'Q0,' + (bodyH+6) + ' ' + hw + ',' + bodyH + ' ';
      svg += 'L' + ww + ',' + wY + ' ';
      svg += 'L' + cw + ',' + armpitY + ' ';
      svg += 'L' + (sr+18) + ',52 ';
      svg += 'L' + (sr+sleeveOut-4) + ',' + sleeveTipY + ' ';
      svg += 'L' + (sr+sleeveOut-5) + ',31 ';
      svg += 'L' + sr + ',17 ';
      svg += 'L20,4 ';
      svg += neckPath;
      svg += '" class="sc-garment-shape"/>';

      svg += '<path d="M' + (sl-18) + ',51 L' + (sl-sleeveOut+4) + ',' + sleeveTipY + ' M' + (sr+18) + ',51 L' + (sr+sleeveOut-4) + ',' + sleeveTipY + '" class="sc-detail-line"/>';
      svg += '<path d="M' + (-hw) + ',' + (bodyH-7) + ' Q0,' + (bodyH+1) + ' ' + hw + ',' + (bodyH-7) + '" class="sc-detail-soft"/>';
      svg += '<path d="M' + (-ww+7) + ',' + (wY-5) + ' L' + (-hw+4) + ',' + (bodyH-4) + ' M' + (ww-7) + ',' + (wY-5) + ' L' + (hw-4) + ',' + (bodyH-4) + '" class="sc-detail-soft"/>';

      if (state.garment === 'K') {
        // Polo collar and placket.
        svg += '<path d="M-20,4 L-8,18 L0,11 L8,18 L20,4 M-8,18 L0,22 L8,18 M0,22 L0,58" class="sc-detail-line"/>';
        svg += '<circle cx="0" cy="30" r="1.5" fill="#999"/>';
        svg += '<circle cx="0" cy="42" r="1.5" fill="#999"/>';
        svg += '<circle cx="0" cy="54" r="1.5" fill="#999"/>';
      } else {
        // Crew neck ribbing.
        svg += '<path d="M-19,5 Q0,19 19,5" class="sc-detail-line"/>';
        svg += '<path d="M-13,10 Q0,17 13,10" class="sc-detail-soft"/>';
      }
      svg += '</g>';

      var py = 18;
      var rightLaneX = 552;
      var leftLaneX = 148;
      var pPositions = {
        'Shoulder': { x1: cx+sl, y1:py+17, x2: cx+sr, y2:py+17, lx: rightLaneX, ly:32, side:'right' },
        'Chest':    { x1: cx-cw, y1:py+armpitY, x2: cx+cw, y2:py+armpitY, lx: rightLaneX, ly:74, side:'right' },
        'Waist':    { x1: cx-ww, y1:py+wY, x2: cx+ww, y2:py+wY, lx: rightLaneX, ly:116, side:'right' },
        'Hem':      { x1: cx-hw, y1:py+bodyH, x2: cx+hw, y2:py+bodyH, lx: rightLaneX, ly:158, side:'right' },
        'Length':   { x1: cx+8, y1:py+8, x2: cx+8, y2:py+bodyH, lx: rightLaneX, ly:206, side:'right', leadFrom:'end' },
        'Biceps':   { x1: cx+sl-15, y1: py+22, x2: cx+sl-29, y2: py+53, leadX: cx+sl-22, leadY: py+37, lx: leftLaneX, ly:68, elbowX: 214, side:'left' },
        'Sleeve Length': {
          shape:'polyline',
          points:[
            [cx+sl, py+17],
            [cx+sl-sleeveOut+5, py+31],
            [cx+sl-sleeveOut+3, py+sleeveTipY]
          ],
          lx: leftLaneX,
          ly: 124,
          elbowX: 186,
          side:'left',
          leadFrom:'end'
        },
        'Sleeve Hem': {
          x1: cx+sl-18,
          y1: py+52,
          x2: cx+sl-sleeveOut+3,
          y2: py+sleeveTipY,
          leadX: cx+sl-28.5,
          leadY: py+54.5,
          lx: leftLaneX,
          ly: 180,
          elbowX: 160,
          side:'left'
        }
      };
      for (var name in measurements) {
        var pos = pPositions[name];
        if (!pos) continue;
        svg += renderMeasAnnotation(pos, name, measurements[name] + ' ' + u);
      }
    }

    svg += '</svg>';
    area.innerHTML = svg;
    renderTable(measurements, u);
  }

  function renderMeasAnnotation(pos, name, val) {
    var s = '';
    var lx = pos.lx, ly = pos.ly;
    var points = pos.points || null;
    var baseX1 = points ? points[0][0] : (pos.x1 != null ? pos.x1 : (pos.cx != null ? pos.cx : 0));
    var baseY1 = points ? points[0][1] : (pos.y1 != null ? pos.y1 : (pos.cy != null ? pos.cy : 0));
    var baseX2 = points ? points[points.length - 1][0] : (pos.x2 != null ? pos.x2 : baseX1);
    var baseY2 = points ? points[points.length - 1][1] : (pos.y2 != null ? pos.y2 : baseY1);
    var mx = pos.cx != null ? pos.cx : (baseX1 + baseX2) / 2;
    var my = pos.cy != null ? pos.cy : (baseY1 + baseY2) / 2;
    var tw = Math.max(val.length * 6.5, name.length * 5) + 14;
    var th = 32;
    var side = pos.side || (lx > 390 ? 'right' : lx < 310 ? 'left' : 'center');
    var anchor = side === 'right' ? lx : side === 'left' ? lx - tw : lx - tw / 2;
    var edgeX = side === 'right' ? anchor : side === 'left' ? anchor + tw : lx;
    var edgeY = ly;
    var hasExplicitLead = pos.leadX != null && pos.leadY != null;
    var leadX = hasExplicitLead ? pos.leadX : mx;
    var leadY = hasExplicitLead ? pos.leadY : my;
    if (!hasExplicitLead) {
      if (pos.leadFrom === 'start') {
        leadX = baseX1; leadY = baseY1;
      } else if (pos.leadFrom === 'end') {
        leadX = baseX2; leadY = baseY2;
      } else if (side === 'right') {
        leadX = Math.max(baseX1, baseX2);
        leadY = baseX1 > baseX2 ? baseY1 : baseY2;
      } else if (side === 'left') {
        leadX = Math.min(baseX1, baseX2);
        leadY = baseX1 < baseX2 ? baseY1 : baseY2;
      }
    }

    // Measurement line
    if (pos.shape === 'ellipse') {
      s += '<g transform="rotate(' + (pos.rotate || 0) + ' ' + pos.cx + ' ' + pos.cy + ')">';
      s += '<ellipse cx="' + pos.cx + '" cy="' + pos.cy + '" rx="' + pos.rx + '" ry="' + pos.ry + '" class="sc-meas-line" fill="none" vector-effect="non-scaling-stroke"/>';
      s += '</g>';
      s += '<circle cx="' + leadX + '" cy="' + leadY + '" r="3" class="sc-meas-dot"/>';
    } else if (pos.shape === 'polyline') {
      var pointStr = points.map(function(point) { return point[0] + ',' + point[1]; }).join(' ');
      s += '<polyline points="' + pointStr + '" class="sc-meas-line" fill="none" vector-effect="non-scaling-stroke"/>';
      s += '<circle cx="' + baseX1 + '" cy="' + baseY1 + '" r="3" class="sc-meas-dot"/>';
      s += '<circle cx="' + baseX2 + '" cy="' + baseY2 + '" r="3" class="sc-meas-dot"/>';
    } else if (baseX1 !== baseX2 || baseY1 !== baseY2) {
      s += '<line x1="' + baseX1 + '" y1="' + baseY1 + '" x2="' + baseX2 + '" y2="' + baseY2 + '" class="sc-meas-line" vector-effect="non-scaling-stroke"/>';
      s += '<circle cx="' + baseX1 + '" cy="' + baseY1 + '" r="3" class="sc-meas-dot"/>';
      s += '<circle cx="' + baseX2 + '" cy="' + baseY2 + '" r="3" class="sc-meas-dot"/>';
    } else {
      s += '<circle cx="' + baseX1 + '" cy="' + baseY1 + '" r="3" class="sc-meas-dot"/>';
    }

    // Elbowed leader line to keep labels in clear lanes.
    if (side === 'center') {
      edgeY = ly > leadY ? ly - th / 2 : ly + th / 2;
      s += '<polyline points="' + leadX + ',' + leadY + ' ' + leadX + ',' + edgeY + ' ' + edgeX + ',' + edgeY + '" class="sc-meas-leader"/>';
    } else {
      var elbowX = pos.elbowX || (side === 'right' ? edgeX - 18 : edgeX + 18);
      s += '<polyline points="' + leadX + ',' + leadY + ' ' + elbowX + ',' + leadY + ' ' + elbowX + ',' + edgeY + ' ' + edgeX + ',' + edgeY + '" class="sc-meas-leader"/>';
    }

    // Label background
    s += '<rect x="' + anchor + '" y="' + (ly - 16) + '" width="' + tw + '" height="' + th + '" rx="3" ry="3" class="sc-meas-bg"/>';
    var tx = anchor + tw / 2;
    s += '<text x="' + tx + '" y="' + (ly - 2) + '" text-anchor="middle" class="sc-meas-name">' + name + '</text>';
    s += '<text x="' + tx + '" y="' + (ly + 11) + '" text-anchor="middle" class="sc-meas-label">' + val + '</text>';
    return s;
  }

  function renderTable(measurements, u) {
    var tbody = document.getElementById('sc-table-body');
    var html = '';
    for (var name in measurements) {
      html += '<tr><td>' + name + '</td><td><strong>' + measurements[name] + '</strong> ' + u + '</td></tr>';
    }
    if (!html && !window.SizeChartData) {
      html = '<tr><td colspan="2" style="text-align:center;color:#9b6f5d;padding:20px;">Size data is still loading. If this stays blank, confirm the theme asset is named exactly <strong>size-chart-data.js</strong>.</td></tr>';
    }
    if (!html) html = '<tr><td colspan="2" style="text-align:center;color:#999;padding:20px;">No data available for this combination</td></tr>';
    tbody.innerHTML = html;
  }

  // ---- COLLAPSED CARD UPDATE ----
  // Copies the icon SVG and labels from the matching selector button into the collapsed card,
  // so the collapsed view always mirrors the active garment without duplicating SVG markup.
  function updateCollapsedCard() {
    var code = state.garment;
    var btn = document.querySelector('.sc-garment-btn[data-garment="' + code + '"]');
    var iconHost = document.getElementById('sc-collapsed-icon');
    var nameEl = document.getElementById('sc-collapsed-name');
    var typeEl = document.getElementById('sc-collapsed-type');
    var meta = garmentDisplay[code] || { name: code, type: '' };
    if (nameEl) nameEl.textContent = meta.name;
    if (typeEl) typeEl.textContent = meta.type;
    if (iconHost && btn) {
      var srcIcon = btn.querySelector('.sc-garment-icon');
      iconHost.innerHTML = srcIcon ? srcIcon.innerHTML : '';
    }
  }

  // ---- TOGGLE GARMENT SELECTOR ----
  window.toggleGarmentSelector = function() {
    var wrap = document.getElementById('sc-garment-selector-wrap');
    var changeBtn = document.querySelector('.sc-change-btn');
    if (!wrap) return;
    var willOpen = wrap.hasAttribute('hidden');
    if (willOpen) {
      wrap.removeAttribute('hidden');
      if (changeBtn) changeBtn.classList.add('open');
    } else {
      wrap.setAttribute('hidden', '');
      if (changeBtn) changeBtn.classList.remove('open');
    }
  };

  // ---- EVENT HANDLERS ----
  window.selectGarment = function(btn) {
    document.querySelectorAll('.sc-garment-btn').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    state.garment = btn.dataset.garment;
    updateCollapsedCard();
    // Auto-collapse the selector after a choice — that's the whole point of the change pattern.
    var wrap = document.getElementById('sc-garment-selector-wrap');
    var changeBtn = document.querySelector('.sc-change-btn');
    if (wrap) wrap.setAttribute('hidden', '');
    if (changeBtn) changeBtn.classList.remove('open');
    renderDiagram();
  };

  window.selectType = function(btn) {
    state.type = 'G';
    renderDiagram();
  };

  window.selectSize = function(btn, dim) {
    var groupId = dim === 'height' ? 'sc-height-group' : dim === 'bodyType' ? 'sc-bodytype-group' : 'sc-chest-group';
    document.querySelectorAll('#' + groupId + ' .sc-size-btn').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    state[dim] = btn.dataset.val;
    renderDiagram();
  };

  window.selectUnit = function(btn) {
    document.querySelectorAll('.sc-unit-btn').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    state.unit = btn.dataset.unit;
    renderDiagram();
  };

  window.closeSizeChart = function() {
    document.getElementById('size-chart-modal').style.display = 'none';
    document.body.style.overflow = '';
  };

  window.refreshSizeChartData = function() {
    var modal = document.getElementById('size-chart-modal');
    if (modal && modal.style.display !== 'none') renderDiagram();
  };

  // Auto-detect garment from product page
  function detectGarment() {
    // 1. Check the data-garment attribute set by Liquid
    var triggerBtn = document.getElementById('size-chart-trigger');
    var liquidGarment = triggerBtn ? triggerBtn.dataset.garment : '';
    if (liquidGarment && 'KSAHN'.indexOf(liquidGarment) !== -1) return liquidGarment;

    // 2. Fallback: detect from current URL or page title
    var pageText = (window.location.href + ' ' + document.title).toLowerCase();
    if (pageText.indexOf('kessler') !== -1) return 'K';
    if (pageText.indexOf('sawyer') !== -1) return 'S';
    if (pageText.indexOf('atticus') !== -1) return 'A';
    if (pageText.indexOf('harrington') !== -1) return 'H';
    if (pageText.indexOf('newman') !== -1) return 'N';

    // 3. Fallback: scan product-title element on page (common Shopify class)
    var titleEl = document.querySelector('.product__title, .product-title, [data-product-title], h1.title');
    if (titleEl) {
      var titleText = titleEl.textContent.toLowerCase();
      if (titleText.indexOf('kessler') !== -1) return 'K';
      if (titleText.indexOf('sawyer') !== -1) return 'S';
      if (titleText.indexOf('atticus') !== -1) return 'A';
      if (titleText.indexOf('harrington') !== -1) return 'H';
      if (titleText.indexOf('newman') !== -1) return 'N';
    }

    return null; // no match, keep current selection
  }

  function applyGarmentSelection(garmentCode) {
    if (!garmentCode) return;
    state.garment = garmentCode;
    // Update button UI
    document.querySelectorAll('.sc-garment-btn').forEach(function(b) {
      b.classList.toggle('active', b.dataset.garment === garmentCode);
    });
    updateCollapsedCard();
  }

  // Trigger
  var __scTrigger = document.getElementById('size-chart-trigger');
  if (__scTrigger) {
  __scTrigger.addEventListener('click', function() {
    // Auto-select garment before opening
    var detected = detectGarment();
    if (detected) applyGarmentSelection(detected);
    else updateCollapsedCard();
    state.type = 'G';

    // Make sure the selector starts collapsed every open.
    var wrap = document.getElementById('sc-garment-selector-wrap');
    var changeBtn = document.querySelector('.sc-change-btn');
    if (wrap) wrap.setAttribute('hidden', '');
    if (changeBtn) changeBtn.classList.remove('open');

    var __scModal = document.getElementById('size-chart-modal');
    if (__scModal) __scModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    renderDiagram();
  });
  }

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSizeChart();
  });

  // Initialise collapsed card on load so it shows the default garment immediately.
  updateCollapsedCard();

})();